const isSecureOrigin = window.location.protocol === 'https:';
const COOKIE_FLAGS = isSecureOrigin ? '; SameSite=None; Secure' : '; SameSite=Lax';

export const setCookie = (name: string, value: string, hours?: number) => {
  let expires = '';
  if (hours) {
    const date = new Date();
    date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/' + COOKIE_FLAGS;
};

// Track if we've already initiated logout to prevent multiple redirects
let isLoggingOut = false;

export const getCookie = (name: string): string | null => {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  
  // If we're looking for accessToken and it's not found, redirect to login portal
  if (name === 'accessToken' && !isLoggingOut) {
    const currentPath = window.location.pathname;
    // Only redirect if we're not already on login/logout/callback pages
    if (currentPath !== '/' && currentPath !== '/logout' && currentPath !== '/callback' && currentPath !== '/accessDenied') {
      console.log('Access token not found, redirecting to login portal');
      isLoggingOut = true;

      const loginUrl = process.env.REACT_APP_LOGIN_URL || 'https://login.peoplelens.ai';
      // Use a small delay to allow any pending operations to complete
      setTimeout(() => {
        window.location.href = loginUrl;
      }, 100);
    }
  }
  
  return null;
};

export const eraseCookie = (name: string) => {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

// Cross-tab communication for logout
export const broadcastLogout = () => {
  localStorage.setItem('logout-event', JSON.stringify({
    type: 'LOGOUT',
    timestamp: Date.now()
  }));
  // Remove the item immediately to trigger storage event
  localStorage.removeItem('logout-event');
};

// Token validation
export const isTokenExpired = (token: string): boolean => {
  if (!token) return true;
  
  try {
    // JWT tokens have 3 parts separated by dots
    const payload = token.split('.')[1];
    if (!payload) return true;
    
    const decoded = JSON.parse(atob(payload));
    const currentTime = Date.now() / 1000;
    
    // Check if token has expired (exp claim is in seconds)
    return decoded.exp ? decoded.exp < currentTime : false;
  } catch (error) {
    console.error('Error checking token expiry:', error);
    return true; // Treat invalid tokens as expired
  }
};

export const clearAllAuthCookies = () => {
  eraseCookie('accessToken');
  eraseCookie('tenantId');
  eraseCookie('userId');
  eraseCookie('persona');
  eraseCookie('designation');
};